import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { VisibleGroupsModule } from '@main-client/src/app/core/visible-groups.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';

import { ProfileIntroMenuComponent } from '@main-client/src/app/profile/profile-intro-menu/profile-intro-menu.component';

@NgModule({
  declarations: [ProfileIntroMenuComponent],
  exports: [ProfileIntroMenuComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    RouterModule,
    TranslationLookupModule,
    VisibleGroupsModule,
  ],
})
export class ProfileIntroMenuModule {}
